import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";
import { useTranslation } from "../../i18n";

// Components
import FormContactComponents from "../../components/contact/formContactComponents";
export default function Index() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);
  const { t } = useTranslation();

  return (
    <div className="contact">
      {isMobile ? (
        // Mobile View
        <div className="row mb-4">
          <div className="col-12">
            <div className="title text-capitalize font-size-18 font-vietnam-400-italic">
              {t.contact.kicker}
            </div>
            <h1 className="text-capitalize font-size-36 font-vietnam-600 lh-1">
              {t.contact.title.join(" ")}
            </h1>
            <p className="font-vietnam-400-italic font-size-18">
              {t.contact.body}
            </p>

            <FormContactComponents />
          </div>
        </div>
      ) : (
        // Desktop View
        <div className="row">
          <div className="col-6">
            <div className="title text-capitalize font-size-18 font-vietnam-400-italic">
              {t.contact.kicker}
            </div>
            <h1 className="text-capitalize font-size-50 font-vietnam-600">
              {t.contact.title[0]} <br /> {t.contact.title[1]}
            </h1>
            <p className="font-vietnam-400-italic font-size-18">
              {t.contact.body}
            </p>

            <FormContactComponents />
          </div>
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <div className="images w-100">
                  <img
                    src={require("../../assets/images/contact/contact_1.jpg")}
                    alt="services"
                    width={"100%"}
                    loading="lazy"
                    className="rounded-3 images-gray"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
